<template>
  <tr>
    <td class="fw-bold">
      <div class="text-dark fw-bolder text-hover-primary mb-1 fs-6">
        {{ this.date }}
      </div>
    </td>
    <td>
      <span :class="paymentTypeClasses">{{ this.typeOrOption }}</span>
    </td>
    <td class="text-end">
      <div class="text-dark fw-bolder text-hover-primary mb-1 fs-6">
         {{ this.amount }}
      </div>
    </td>
  </tr>
</template>

<script>
import Vue from "vue";
import dayjs from "dayjs";
import { formatCurrency } from "@/mixins/shared";

export default Vue.extend({
  props: {
    Amount: {
      type: Number,
      required: true,
    },
    Date: {
      type: String,
      required: true,
    },
    PaymentType: {
      type: String,
      required: true
    },
    PaymentOption: {
      type: String,
      required: true,
    },
    PaymentId: {
      type: String,
      required: false,
    },
    Success: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      paymentTypeMap: {
        OrderBarrel: "Order Barrel",
        CustomsDuty: "Customs Duty",
      },

      paymentOptionsType: {
        UPFRONT : "Full Payment",
        STAGES : "Part Payment",
      }
    };
  },
  computed: {
    amount() {
      return formatCurrency(this.Amount);
    },
    date() {
      return dayjs(this.Date).format("dddd, MMMM D, YYYY h:mm A");
    },
    type() {
      return this.paymentTypeMap[this.PaymentType] ?? this.PaymentType;
    },
    option() {
      return this.paymentOptionsType[this.PaymentOption];
    },

    typeOrOption() {
      return this.PaymentType == "OrderBarrel" ? this.option : this.type
    },
    paymentTypeClasses() {
      return this.Success
        ? "badge badge-light-primary"
        : "badge badge-light-danger";
    },
  },
});
</script>

<style scoped></style>
